import React from 'react'
import { IFlashNews } from '@verzekeringapp-mono/shared/src/models/flash_news'

const FlashNews: React.FC<{ flashNews: IFlashNews}> = ({ flashNews }) => {

  const onPressReadMore = () => {
    if (flashNews?.link && flashNews.link.includes('https://')) {
      window.open(flashNews.link, '_blank')
    }
  }

  return (
    <div className={'flex flex-1 flex-col gap-4 rounded-lg bg-surface-card p-8'}>
      {
        flashNews.label && (
          <p className='font-bold text-text-brand'>
            {flashNews.label}
          </p>
        )
      }

      <p>{flashNews?.title}</p>

      <div
        className='html-content'
        dangerouslySetInnerHTML={{ __html: flashNews?.content || '' }}
      />

      {(flashNews?.linkText && flashNews?.link) && (
        <button
          className='paragraph-light pt-2 text-text-brand'
          onClick={onPressReadMore}
        >
          Lees meer
        </button>
      )}
    </div>
  )
}

export default FlashNews
